const corporateType = {
  RESELLER: "corporate-reseller",
  GROUP: "corporate-group",
  SUBSIDIARY: "corporate-subsidiary",
} as const;

type CorporateTypeKey = keyof typeof corporateType;

// LANDING and SERVICE have no theme route of their own, and an unrecognised
// value is a scope this build does not know about. Both land here on purpose.
// RESELLER used to land here too, which put a payer on a page asking for money
// under the wrong organisation's name, colours and logo.
export const CORPORATE_TYPE_FALLBACK = corporateType.GROUP;

const getCorporateType = (val: string): string => {
  if (val in corporateType) {
    return corporateType[val as CorporateTypeKey];
  }
  return CORPORATE_TYPE_FALLBACK;
};

export default getCorporateType;
